<template>
    <div class="articules">
        <Header/>
        <div class="title">
            <span>Blog</span>
            <h1>Aprende con nuestros Post</h1>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
        </div>
        <div class="info top">
            <h1>Aprende con nuestros posts como gestionar tus riesgos laborales y empresariales, suscríbete para que estés al día sobre la tendencias a riesgos</h1>
        </div>
        <div class="articule-list">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                <div v-for="(item, index) in articules" :key="index">
                    <div class="image"><img :src="item.portada" alt=""></div>
                    <div class="infos">
                        <span>{{ item.subtitulo }}</span>
                        <h3>{{ item.titulo.substring(0,30) + '...'  }}</h3>
                        <p>{{ item.info.substring(0,100) + '...' }}</p>
                        <button @click="$router.push('blog/' + item.id + '/' + item.titulo)">Ver mas</button>
                        <div>{{ item.nombre }}</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Header from './../Header/Header'
import Footer from './../Footer/Footer'
import API from '@/api'

export default {
    name: 'articules',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            articules: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false
        }
    },
    methods: {
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.articules.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getArticulesList()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getArticulesList() {
            API.getArticulesList(this.limit, this.offset)
                .then((res) => {
                    res.map(item => { this.articules.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        }
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
        this.getArticulesList()
    }
}
</script>

<style scoped>
.title {
    background-image: url('../../assets/blog.webp');
    padding: 200px 200px;
    color: #fff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
}
.title > span {
    font-family: 'JLI';
    font-size: 40px;
}
.title > h1 {
    font-family: 'JBD';
    font-size: 50px;
}
#contactForm {
    margin-top: -100px;
    font-family: 'JR';
    background-color: #fff;
    padding: 40px;
    position: absolute;
    border-radius: 10px;
    width: 400px;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    font-weight: bolder;
    right: 100px;
}
#contactForm > label {
    color: #65b24a;
    font-size: 24px;
    line-height: 25px;
}
.info {
    padding: 100px 0px;
}
.info > h1 {
    width: 60%;
    font-family: 'JBD';
    color: #65b24a;
    padding-left: 200px;
    font-size: 40px;
}
.info > p {
    font-family: 'JR';
    width: 60%;
    padding-left: 200px;
    margin-top: 10px;
    font-size: 30px;
}

.articule-list {
    padding: 20px 100px;
    width: 100%;
}
.articule-list > div {
    width: 100%;
}
.articule-list > div > div{
    width: 50%;
    display: inline-flex;
}

.articule-list > div > div > div.image {
    padding: 20px;
    display: inline-block
}

.articule-list > div > div > div.image > img{
    object-fit: cover;
    width: 300px;
    height: 350px;
}

.articule-list > div > div > div.infos {
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
    height: 300px;
    padding: 10;
    padding-top: 20px;
    margin-top: 80px;
    margin-left: -100px;
    z-index: 0;
    padding-left: 100px;
    text-align: justify;
    font-family: 'JR';
    position: relative;
}
.articule-list > div > div > div.infos > div{
    padding: 20px;
    float: right;
    color: #2d4f98;
    font-weight: bold;
    font-style: oblique;
}

.articule-list > div > div > div.infos > span{
    margin-top: 1000px;
    color: #000;
    font-weight: bold;
}
.articule-list > div > div > div.infos > h3{
    margin-top: 20px;
    color: #2d4f98;
    text-align: left;
    font-family: 'JBD';
}
.articule-list > div > div > div.infos > p{
    color: #000;
    text-align: left;
}
.articule-list > div > div > div.infos > button{
    position: absolute;
    background-color: #65b24a;
    width: 150px;
    height: 40px;
    text-align: center;
    border-radius: 20px;
    padding: 5px;
    border-color: #65b24a;
    border-style: solid;
    font-size: 20px;
    color: #fff;
    margin-top: 20px;
    bottom: 40px;
    cursor: pointer;
}

.articule-list > div > div > div > button:hover {
    color: #65b24a;
    background-color: #fff;
    cursor: pointer;
}

@media (max-width: 1500px) {
    .title {
        padding: 200px 200px;
    }
    .info > h1 {
        padding-left: 200px;
    }
}

@media (max-width: 1400px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .title {
        padding: 200px 100px;
    }
    .info > h1 {
        padding-left: 100px;
    }
}

@media (max-width: 1300px) {
    .info > h1 {
        font-size: 30px;
    }
    .articule-list {
        padding: 20px 100px;
        width: 100%;
        display: inline-flex;
    }
    .articule-list > div > div{
        width: 50%;
        align-items: center;
        justify-items: center;
        display: inline-block;
    }
    .articule-list > div > div > div.image {
        padding: 20px;
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div > div.infos {
        margin-top: -30px;
        width: 100%;
        margin-left: 0px;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div > div.infos > button{
        left: 0px;
    }
    .articule-list > div > div > div.infos > div{
        margin-top: 50px;
    }
}

@media (max-width: 1100px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    #contactForm {
        margin-top: -100px;
        right: 50px;
    }
}

@media (max-width: 1000px) {
    .title {
        padding: 50px 0px;
        height: 400px;
        text-align: center;
    }
    #contactForm {
        margin-top: 10px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .info {
        padding-top: 400px;
        width: 100%;
        text-align: center;
    }
    .info > h1 {
        padding: 10px;
        width: 100%;
        text-align: center;
    }
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: flex;
        width: 80%;
    }
    .articule-list > div > div > div.infos {
        margin-left: -100px;
    }
    .articule-list > div > div > div.infos > button{
        position:relative;
    }
}

@media (max-width: 800px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: flex;
        width: 100%;
    }
    .articule-list > div > div > div.infos > button{
        position:relative;
    }
}

@media (max-width: 750px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: grid;
        width: 100%;
    }
    .articule-list > div > div > div.infos > button{
        position:relative;
    }
}

@media (max-width: 500px) {
    #contactForm {
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Blog/Articules.vue